import type { SanitizerConfig } from '@editorjs/editorjs';

// Unified span allowlist for ref chips (class + data-ref-id) and color spans
// (style). EditorJS merges inline-tool sanitize configs with shallow
// Object.assign — without a comprehensive block-tool text config, ColorTool's
// span:{style:true} overwrites ReferenceTool's class/data-ref-id and chips
// collapse to visible labels on editor.save().
export const SPAN_SANITIZE = {
  class: true,
  style: true,
  contenteditable: true,
  'data-ref-id': true,
  'data-kind': true,
  'data-status': true,
  'data-broken': true,
  'data-lost': true,
} as const;

// Block-tool field config wins the per-field merge over inline tools, so this
// overrides the inline span conflict and preserves canonical strong/em tags
// (stored by normalizeInlineHtml) that the default Paragraph allowlist strips.
export const PARAGRAPH_SANITIZE = {
  text: {
    br: true,
    b: true,
    strong: true,
    i: true,
    em: true,
    u: true,
    s: true,
    span: SPAN_SANITIZE,
  },
} as unknown as SanitizerConfig;
